import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function Forbidden() {
  return (
    <>
      <SEO
        title="403 - Adgang nægtet"
        description="Du har ikke tilladelse til at tilgå denne side på Caspers Træservice."
      />

      <section className="py-24 sm:py-32 bg-[#FBF9F5] flex items-center justify-center min-h-[70vh]">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center space-y-6">
          <div className="w-20 h-20 rounded-2xl bg-[#EFE8DC] text-[#1E4231] flex items-center justify-center text-4xl mx-auto shadow-inner border border-[#D8CEBD]">
            <i className="fa-solid fa-lock text-[#D9691E]" aria-hidden="true" />
          </div>

          <span className="text-xs font-bold uppercase tracking-widest text-[#D9691E] bg-[#D9691E]/10 px-3.5 py-1.5 rounded-full inline-block">
            Fejl 403
          </span>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#12281D] tracking-tight">
            Adgang nægtet
          </h1>

          <p className="text-base sm:text-lg text-[#526D5F] leading-relaxed max-w-md mx-auto">
            Du har desværre ikke adgang til denne ressource. Vend sikkert tilbage til forsiden eller vores kontaktsektion.
          </p>

          <div className="pt-4 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-[#1E4231] hover:bg-[#285741] text-white px-6 py-3.5 rounded-xl font-bold text-sm shadow-md transition-all whitespace-nowrap"
            >
              <i className="fa-solid fa-house" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>

            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 bg-[#D9691E] hover:bg-[#C25B15] text-white px-6 py-3.5 rounded-xl font-bold text-sm shadow-md transition-all whitespace-nowrap"
            >
              <span>Kontakt os</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
